module.exports = __webpack_public_path__ + "static/flarnie-494c2bf9a31621ef8c5abbb5899bbd9a.png";